export default "__VITE_ASSET__fcd68952__"